<template>
  <div class="permission-index">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 新增账号</el-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #username="{ row }">{{ row.username }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #malls="{ row }">{{ row.malls }}</template>
      <template #disable="{ row }">
        <el-switch
          :value="!row.disable"
          active-color="#05C8AF"
          inactive-color="#F2F3F5"
          v-on:change="(value) => onStatusChange(value, row)"
        >
        </el-switch>
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="onResetPW(scope.row)" class="error" >重置密码</el-button >
        <el-button type="text" @click="onEdit(scope.row)" class="ml10">编辑</el-button>
      </template>
    </Table>
    <Dialog :dialogShow="isShowResetPWDialog" title="重置密码">
      <template>
        <div class="new-PW">
          <el-row class="row">
            <el-col :span="4" class="col col-title">账号：</el-col>
            <el-col :span="18" class="col">{{resetPWResult.username}}</el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="4" class="col col-title">新密码：</el-col>
            <el-col :span="18" class="col">
              <span>{{resetPWResult.password}}</span>
              <span class="hint">（随机生成）</span>
            </el-col>
          </el-row>
          <el-row class="footer">
            <el-button class="fun-btn mr20" @click="onCopyPW">复制</el-button>
            <el-button class="fun-btn" type="primary" @click="isShowResetPWDialog = false">确定</el-button>
          </el-row>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { api_getTableList, api_putResetPW, api_putChangeDisable } from '@/api/account'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from '@/components/Dialog/index'
import aes from '@/common/aes.js'
import {copytext} from '@/utils/index.js'
export default {
  name: "pIndex",
  mixins: [tableList],
  components: {
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "账号",
          placeholder: "请输入账号",
          type: "input",
          key: "username",
        },
        {
          label: "姓名",
          placeholder: "请输入姓名",
          type: "input",
          key: "name",
        },
        {
          label: "商场名称",
          type: "mall",
          key: "mallId",
          multiple: false
        },
      ],
      form: {
        username: "",
        name: "",
      },
      tableThData: [
        { prop: "username", label: "账号", minWidth: "180", },
        { prop: "name", label: "姓名", minWidth: "180", },
        { prop: "malls", label: "商场名称", minWidth: "180", },
        { prop: "disable", label: "状态", minWidth: "180", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],

      isShowResetPWDialog: false, // 控制密码重置后弹窗的显示隐藏
      resetPWResult: {}, // 密码重置结果数据
    };
  },
  created () {
  },
  methods: {

    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getTableList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击状态切换开关
    async onStatusChange(value, row) {
      this.$baseConfirm(`是否${value ? '启用': '停用'}该账号？`, {
        center: true
      }, async () => {
        const res = await api_putChangeDisable({id: row.id})
        this.$baseMessage('操作成功', 'success')
        this.getList()
      })
    },

    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/permission/index/add"
      });
    },

    // 点击编辑按钮
    onEdit(row) {
      this.$router.push(`/permission/index/add?id=${row.id}`);
    },

    // 点击重置密码按钮
    onResetPW(row) {
      this.$baseConfirm(
        '是否确认重置密码？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
        const res = await api_putResetPW({id: row.id})
        this.$baseMessage('操作成功', 'success')
        this.resetPWResult = {
          username: res.username,
          password: aes.decrypt(res.password)
        }
        this.isShowResetPWDialog = true
      })
    },

    // 点击复制密码按钮
    onCopyPW() {
      const str = `账号：${this.resetPWResult.username}   密码：${this.resetPWResult.password}`
      const result = copytext(str)
      result && this.$baseMessage('复制成功', 'success')
    },

  },
  watch: {
    isShowResetPWDialog: {
      handler(newValue) {
        if (!newValue) {
          this.resetPWResult = {}
        }
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.permission-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .new-PW {
    margin-top: 50px;

    .row  {
      height: 50px;
      line-height: 50px;

      .col {
        font-size: 16px;
        color: #333333;
      }

      .col-title {
        text-align: right;
        margin-right: 20px;
      }

      .hint {
        font-size: 12px;
        color: #666666;
      }
    }

    .footer {
      position: absolute;
      left: 0;
      right: 30px;
      bottom: 30px;
      text-align: right;
    }
  }
}
</style>
